import { Component, Inject, ViewChild, AfterViewChecked, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DocumentNotesData } from '../../models/document-notes.model';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-view-add-doc-notes',
  templateUrl: './view-add-doc-notes.component.html',
  styleUrl: './view-add-doc-notes.component.scss'
})

export class ViewAddDocNotesComponent implements OnInit, AfterViewChecked {

  displayedColumns: string[] = [
    'entryDate',
    'entryUsername',
    'text'
  ];
  dataSource: MatTableDataSource<DocumentNotesData>;
  @ViewChild(MatSort) sort!: MatSort;
  comment: any;
  hideSave: boolean = true;
  showSpinner: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<ViewAddDocNotesComponent>,
    private readonly commonService: CommonService
  ) {
    this.dataSource = new MatTableDataSource<DocumentNotesData>([]);
  }

  ngOnInit(): void {
    this.getNoteDetails();
  }

  getNoteDetails(): void {
    if (this.data?.Type == "view") {
      this.hideSave = false;
    }
    this.showSpinner = true;
    this.commonService.getNotesDetails(this.data?.userGpid, this.data?.systemId, this.data?.DocumentId).subscribe({
      next: (response: DocumentNotesData[]) => {
        this.dataSource = new MatTableDataSource<DocumentNotesData>(response);
        this.showSpinner = false;
      },
      error: (error: any) => {
        this.showSpinner = true;
        console.error('Not able to fetch the document history:', error);
      }
    });
  }

  ngAfterViewChecked() {
    this.dataSource!.sort = this.sort;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  get hasData(): boolean {
    return this.dataSource?.data?.length > 0 && !this.showSpinner;
  }

  onSaveComment() {
    if (this.comment && this.comment.length <= 2000) {
      let postObj = { Text: this.comment }
      this.showSpinner = true;
      this.commonService.addDocumentNotes(this.data?.userGpid, this.data?.systemId, this.data?.DocumentId, postObj).subscribe({
        next: (response: boolean) => {
          this.showSpinner = false;
          this.getNoteDetails();
          this.comment = "";
          this.commonService.showMessage("Notes added.", "success");
        },
        error: (error: any) => {
          this.showSpinner = true;
          this.commonService.showMessage("Error in adding notes. " + error.error.message, "error");
          this.comment = "";
        }
      });
    }
  }
}
